<template>
  <div class="pending-item">
    <div class="pending-item__left">
      <head-image
        :id="item && item.visitorInfo ? item.visitorInfo.id : ''"
        :name="item && item.visitorInfo ? item.visitorInfo.nickName : ''"
        :url="item && item.visitorInfo ? item.visitorInfo.headImage : ''"
        :size="45"
        radius="50%"
        :online="Boolean(item && item.online)"
        :isShowUserInfo="false"
      />
    </div>
    <div class="pending-item__center">
      <div class="pending-item__top">
        <el-tooltip effect="dark" :content="visitorName" placement="top">
          <span class="pending-item__name">{{ visitorName }}</span>
        </el-tooltip>
        <span class="pending-item__event">{{ item ? item.transferTime : "" }}</span>
      </div>
      <el-tooltip effect="dark" :content="item ? item.transferReason : ''" placement="top">
        <div class="pending-item__detail">转接原因:{{ item ? item.transferReason : "" }}</div>
      </el-tooltip>
    </div>
    <div class="pending-item__right" v-if="item && item.transferStatus == 1">
      <button
        type="button"
        class="pending-action pending-action--accept"
        :class="{ 'is-loading': isAcceptLoading }"
        :disabled="isItemLoading"
        @click.stop="$emit('accept', item)"
      >
        <i v-if="isAcceptLoading" class="el-icon-loading pending-action__loading"></i>
        <span>{{ isAcceptLoading ? "处理中" : "接收" }}</span>
      </button>
      <button
        type="button"
        class="pending-action pending-action--reject"
        :class="{ 'is-loading': isRejectLoading }"
        :disabled="isItemLoading"
        @click.stop="$emit('reject', item)"
      >
        <i v-if="isRejectLoading" class="el-icon-loading pending-action__loading"></i>
        <span>{{ isRejectLoading ? "处理中" : "拒绝" }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";

export default {
  name: "PendingTransferItem",
  components: {
    HeadImage
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    loadingAction: {
      type: String,
      default: ""
    }
  },
  computed: {
    visitorName() {
      return this.item && this.item.visitorInfo ? this.item.visitorInfo.nickName : "";
    },
    isAcceptLoading() {
      return this.loadingAction === "accept";
    },
    isRejectLoading() {
      return this.loadingAction === "reject";
    },
    isItemLoading() {
      return this.isAcceptLoading || this.isRejectLoading;
    }
  }
};
</script>

<style scoped lang="scss">
.pending-item {
  height: 54px;
  max-height: 54px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px 8px;
  // box-sizing: border-box;
  // border-radius: 10px;
  margin: 0 3px;
  cursor: pointer;
  // border: 1px solid rgba(226, 232, 240, 0.9);
  overflow: hidden;
}

.pending-item__left {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.pending-item__center {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  overflow: hidden;
}

.pending-item__top {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.pending-item__name {
  max-width: 88px;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pending-item__event {
  flex-shrink: 0;
  padding: 1px 6px;
  border-radius: 999px;
  background: rgba(20, 106, 219, 0.08);
  color: #005e9f;
  font-size: 11px;
  line-height: 16px;
}

.pending-item__detail {
  font-size: 12px;
  color: #64748b;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pending-item__right {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 56px;
}

.pending-action {
  width: 56px;
  height: 22px;
  padding: 0;
  border-radius: 11px;
  border: 1px solid #d7deea;
  background: #ffffff;
  color: #334155;
  font-size: 11px;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
  box-sizing: border-box;
  transition: all 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 3px;

  &:hover {
    border-color: #b8c5d8;
    background: #f8fafc;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.9;
  }
}

.pending-action.is-loading {
  pointer-events: none;
}

.pending-action__loading {
  font-size: 10px;
}

.pending-action--accept {
  border-color: rgba(20, 106, 219, 0.16);
  background: rgba(20, 106, 219, 0.08);
  color: #005e9f;

  &:hover {
    border-color: rgba(20, 106, 219, 0.28);
    background: rgba(20, 106, 219, 0.14);
  }
}

.pending-action--reject {
  border-color: rgba(245, 108, 108, 0.18);
  background: rgba(245, 108, 108, 0.08);
  color: #f56c6c;

  &:hover {
    border-color: rgba(245, 108, 108, 0.3);
    background: rgba(245, 108, 108, 0.14);
  }
}
</style>
